<template>
    <v-window-item value="depreciations">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <h2 class="text-h6">Asset Depreciations</h2>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="pa-1">
                    <v-data-table
                        :headers="compnentsHeaders"
                        :items="depreciationsData"
                        :loading="loading"
                        :hover="true"
                        density="compact"
                        elevation="0"
                        class="border-sm rounded-md"
                    >

                        <template v-slot:item.actions="{ item }">
                            <v-btn 
                                icon 
                                size="small" 
                                variant="text" 
                                color="orange"
                                @click="editComponent(item)"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-window-item>
</template>

<script>

export default {
    props: {
        depreciationsData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        }
    },
    components: {},
    data: () => ({
        dialog: false,
        loading: false,
        compnentsHeaders: [
            { title: "#SL", align: "center", key: "id", width: "40px", sortable: false },
            { title: "Period Type", key: "asset_depreciation.period_type", align: "left", sortable: false },
            { title: "Start Date", key: "asset_depreciation.start_date", align: "left", sortable: false },
            { title: "End Date", key: "asset_depreciation.end_date", align: "left", sortable: false },
            { title: "Accumulated Depreciation", key: "accumulated_depreciation", align: "left", sortable: false },
            { title: "Amount", key: "amount", align: "left", sortable: false },
        ],
    }),
    computed: {},
    watch: {},
    created() {},
    methods: {},
    setup(props, {emit}){},
    mounted() {
        
    },
}
</script>